import { search as searchApi } from '../api.js';
import { navigate } from '../utils/router.js';
import { esc, avatarUrl, toast, badgeHtml } from '../utils/dom.js';
import { renderPostCard } from './feed.js';

export function renderSearch(container, { currentUser } = {}) {
  container.innerHTML = `
    <div class="search-box">
      <input type="search" id="search-input" placeholder="搜索文章、GID 或昵称…" autocomplete="off" />
    </div>
    <div id="search-results">
      <div class="empty-state"><p>输入关键词开始搜索</p></div>
    </div>
  `;

  const input = container.querySelector('#search-input');
  const results = container.querySelector('#search-results');
  let timer = 0;
  let lastQ = '';

  const run = async (q) => {
    if (!q) {
      results.innerHTML = `<div class="empty-state"><p>输入关键词开始搜索</p></div>`;
      return;
    }
    results.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
    try {
      const data = await searchApi(q);
      const users = data.users || [];
      const posts = data.posts || [];
      if (!users.length && !posts.length) {
        results.innerHTML = `<div class="empty-state"><p>未找到相关结果</p></div>`;
        return;
      }
      results.innerHTML = '';
      if (users.length) {
        const sec = document.createElement('div');
        sec.innerHTML = `<div class="search-section">用户</div>`;
        users.forEach((u) => {
          const row = document.createElement('div');
          row.className = 'user-row';
          row.innerHTML = `
            <img src="${esc(avatarUrl(u))}" alt="" />
            <div>
              <div class="fw-600">${esc(u.nickname)}${
                badgeHtml(u)
              }</div>
              <div class="text-sm muted">GID ${esc(u.gid)}</div>
              ${u.bio ? `<div class="text-sm faint">${esc(u.bio)}</div>` : ''}
            </div>
          `;
          row.addEventListener('click', () => navigate(`/user/${u.gid}`));
          sec.appendChild(row);
        });
        results.appendChild(sec);
      }
      if (posts.length) {
        const sec = document.createElement('div');
        sec.innerHTML = `<div class="search-section">帖子</div>`;
        const list = document.createElement('div');
        list.className = 'post-list';
        posts.forEach((p) => {
          list.appendChild(renderPostCard(p, { currentUser }));
        });
        sec.appendChild(list);
        results.appendChild(sec);
      }
    } catch (err) {
      results.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
        err.message || '搜索失败'
      )}</p></div>`;
      toast(err.message || '搜索失败', 'error');
    }
  };

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (q === lastQ) return;
      lastQ = q;
      run(q);
    }, 320);
  });

  input.focus();
}
